import { Link } from "react-router-dom";
import React from "react";

interface PortfolioLinkProps {
    id: number;
    name: string;
    target?: string;
    rel?: string;
    className?: string;
}

const PortfolioLink: React.FC<PortfolioLinkProps> = ({ id, name, target, rel, className }) => {
    return (
        <Link to={`/portfolio/${id}`} target={target || "_blank"} rel={rel || "noopener noreferrer"} className={className || "blue-link"}>
            {name}
        </Link>
    );
};

export default PortfolioLink;
